import { useEffect, useRef } from "react"
import axios from "axios"

const useCancelToken = () => {
  const axiosSource = useRef()

  const newCancelToken = () => {
    axiosSource.current = axios.CancelToken.source()
    return axiosSource.current.token
  }

  useEffect(
    () => () => {
      if (axiosSource.current) axiosSource.current.cancel()
    },
    [],
  )

  return {
    newCancelToken,
    isCancel: axios.isCancel,
  }
}

export default useCancelToken
